import {v4 } from "uuid"
import { calculatePriceWithTax, getTaxValue } from "./components/ProductCardComponent/ProductPrice";
import { constants, sc_codes } from './constants';
import handler from "./helpers/jsBridge";
import { BACK_FROM_KIOSK } from "./helpers/jsBridgeEvents";
import idb from './helpers/indexedDB';
export const setCookie = (name, value, days) => {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export const eraseCookie = (name) => {
    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

export const ordinal_suffix_of = (i) => {
    var j = i % 10,
        k = i % 100;
    if (j === 1 && k !== 11) {
        return i + "st";
    }
    if (j === 2 && k !== 12) {
        return i + "nd";
    }
    if (j === 3 && k !== 13) {
        return i + "rd";
    }
    return i + "th";
}

export const validateMobile = (mobile) => {
    var pattern = /^[6-9][0-9]{9}$/;
    if (pattern.test(mobile)) {
        return true;
    }
    return false;
}

export const validatename = (name) => {
    var pattern =  /^[a-zA-Z][a-zA-Z ]{2,}$/;
    if(pattern.test(name)){
        return true;
    }
    return false;
}

export const getPercentange = (partialValue, totalValue) => {
    return (partialValue / 100) * totalValue;
}

export const getCurrentUtcTime = () => {
    let d = (new Date()).getHours() + ':' + (new Date()).getMinutes();
    return d;
  };


export const flag_add = "add";
export const flag_edit = "edit";

export const section_name_restaurant_listing = "restaurant_listing";

export const cart_entity_type_product = "product";
export const cart_entity_type_combo = "combo";
export const coupon_code_remove_flag = "*___remove___*" // Had to be unqiue so the same is not set by the content team. 

const oneDigitNumberFormater = (number) => {
	return parseInt(number) >= 0 ? (+number < 10 ? `0${number}` : number.toString()) : "";
}

const getCurrentDateTime = (addDays) => {
	let today = addDays ? new Date(Date.now() + addDays * 24 * 60 * 60 * 1000) : new Date();
	let date = today.getFullYear() + '-' + oneDigitNumberFormater(today.getMonth() + 1) + '-' + oneDigitNumberFormater(today.getDate());
	let time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
	return date + ' ' + time;
};

const get_formatted_order_date = (delivery_slot) => {

    if (!delivery_slot) return null

    const delivery_slot_hour = parseInt(delivery_slot.split(" - ")[0]);
    const curr_date_time = getCurrentDateTime();
    const [curr_date, curr_time] = curr_date_time.split(' ');
    const curr_date_hour = curr_time.split(":")[0];
    const next_date = getCurrentDateTime(1).split(' ')[0];

    const is_next_day = delivery_slot_hour < 12 && curr_date_hour > delivery_slot_hour;
    const date_to_send = is_next_day ? next_date : curr_date;
    const final_order_date = date_to_send + ' ' + delivery_slot.split(" - ")[0];
    return final_order_date;
};

export const get_formatted_brand_object = ({ entity_from_body, product, combo, store_id, delivery_slot }) => {

	if (!entity_from_body) {
		entity_from_body = product || combo;
	}

	entity_from_body.quantity = entity_from_body.quantity || 1;

	const is_product = entity_from_body.hasOwnProperty("product_name");
	const brand_id = entity_from_body.brand_id;
	const client_source_id = entity_from_body.client_source_id;
	const logo = entity_from_body?.brand_logo_image || entity_from_body?.logo;
	const brand_name = entity_from_body?.brand_display_name || entity_from_body?.brand_name;

	const obj = {
		brand_id, brand_name, logo, client_source_id,
		product: is_product ? [entity_from_body] : [],
		combo: !is_product ? [entity_from_body] : [],
		store_id, timestamp: Date.now(),
		is_future_order: delivery_slot ? 1 : 0,
		delivery_slot: delivery_slot || null,
		order_date: get_formatted_order_date(delivery_slot),
	};

	return obj;
};

const get_updated_entity_array = (entity_array, entity_body, type, flag) => {

	// // Default quantity as 1 if not sent from body
	if (!entity_body.quantity) {
		entity_body.quantity = 1;
	};

	if (flag === flag_edit) {

	} else {
		entity_body.quantity = flag === flag_add ? entity_body.quantity + 1 : entity_body.quantity - 1;
	}

	if (entity_body.quantity === 0) {
		entity_array = entity_array.filter(p => {
			return p.secondary_id !== entity_body.secondary_id
		})
	}

	entity_array = entity_array.map(p => {
		if (p.secondary_id === entity_body.secondary_id) {
			return entity_body
		}
		return p
	});
	return entity_array;
}

const is_customization_same = (new_group_arr, old_group_arr) => {
	const get_cust_sorted_arr_ids = (customisations) => customisations.map(c => Number(c.customisation_id)).sort((a, b) => a - b);

	if (!new_group_arr && !old_group_arr) {
		return true;
	}

	if (!new_group_arr || !old_group_arr) {
		return false
	};

	if (new_group_arr.length !== old_group_arr.length) {
		return false;
	}

	let same = true;


	for (let curr_group1_customisations of new_group_arr) {
		const { id, customisations } = curr_group1_customisations;
		const curr_group_2_customisations = old_group_arr.find(g => g.id === id)?.customisations;

		if (!curr_group_2_customisations) {
			same = false
			break;
		}

		const group_1_cust_ids = get_cust_sorted_arr_ids(customisations);
		const group_2_cust_ids = get_cust_sorted_arr_ids(curr_group_2_customisations);
		if (group_1_cust_ids.toString() !== group_2_cust_ids.toString()) {
			same = false;
			break;
		}

	}

	return same;
}

const is_combo_same = (new_sets, olds_sets) => {
	let is_same = false;

	if (new_sets?.length === olds_sets?.length) {
		let is_all_prod_and_cz_same = true;
		for (let curr_set of new_sets) {
			const curr_set_products = curr_set.products;
			const old_set_mapping_of_curr_set = olds_sets.find(s => s.set_id === curr_set.set_id);

			const products_old_set_mapping_of_curr_set = old_set_mapping_of_curr_set.products;

			// Checking only first element because a set can only have 1 product in a cart
			if (curr_set_products[0]?.product_id === products_old_set_mapping_of_curr_set[0]?.product_id) {
				const new_group_cz_arr = curr_set_products[0]?.customisations_groups;
				const old_group_cz_arr = products_old_set_mapping_of_curr_set[0]?.customisations_groups;
				const is_cz_same = is_customization_same(new_group_cz_arr, old_group_cz_arr);
				if (!is_cz_same) {
					is_all_prod_and_cz_same = false;
					break;
				}
			} else {
				is_all_prod_and_cz_same = false;
				break;
			}
		}

		// If all products and their cz same then....
		if (is_all_prod_and_cz_same) {
			is_same = true;
		}
	}

	return is_same;
}

const entity_exists_in_cart = (entity_body, entity_arr, type, flag) => {

	// When user tried to edit customizations 
	if (flag !== flag_add) {
		return true;
	};


	let exists = false;

	for (let c = 0; c <= entity_arr.length - 1; c++) {
		const curr_cart_entity = entity_arr[c];
		const field = type === cart_entity_type_product ? "product_id" : "combo_id";

		if (curr_cart_entity[field] === entity_body[field]) {
			if (type === cart_entity_type_product) {
				// Check if customization groups are same then return true
				exists = is_customization_same(entity_body.customisations_groups, curr_cart_entity.customisations_groups)
				if (exists) {
					break;
				}
			}
			// This is obvious but still.....
			else if (type === cart_entity_type_combo) {
				exists = is_combo_same(entity_body.sets, curr_cart_entity.sets);
				if (exists) {
					break;
				}
			}
		}
	}
	return exists
}

export const add_entity_to_cart = (cart_object, req_body) => {
	const {
		product: product_from_body, combo: combo_from_body, store_id, delivery_slot, flag,
	} = req_body;

	const entity_from_body = product_from_body || combo_from_body;
	const is_product = entity_from_body.hasOwnProperty("product_id");
	const entity_type = is_product ? cart_entity_type_product : cart_entity_type_combo;

	let final_brands_array = [...cart_object.brands];

	const brand_from_cart_of_entity = final_brands_array.find(({ brand_id }) => brand_id === entity_from_body.brand_id);
	// -------- ADD PRODUCT/COMBO TO EXISTING BRAND ------------
	if (brand_from_cart_of_entity) {
		const { product: product_from_cart, combo: combo_from_cart } = brand_from_cart_of_entity;
		let entity_from_cart = is_product ? product_from_cart : combo_from_cart; // Is of type array

		// -------- SAME PRODUCT/COMBO ITSELF IS USED ------------
		if (entity_exists_in_cart(entity_from_body, entity_from_cart, entity_type, flag)) {
			entity_from_cart = get_updated_entity_array(entity_from_cart, entity_from_body, entity_type, flag);
		} else {
			entity_from_body.quantity = 1;
			entity_from_cart.push(entity_from_body);
		}

		// Reassigning to cart object
		brand_from_cart_of_entity[is_product ? cart_entity_type_product : cart_entity_type_combo] = entity_from_cart;

		// Now if both product and combo are empty then filter out this brand 
		const productLength = brand_from_cart_of_entity?.product?.length || 0;
		const comboLength = brand_from_cart_of_entity?.combo?.length || 0;

		if (productLength === 0 && comboLength === 0) {
			final_brands_array = final_brands_array.filter(b => b.brand_id !== brand_from_cart_of_entity.brand_id);
		}
		else {
			final_brands_array = final_brands_array.map(b => {
				if (b.brand_id === entity_from_cart.brand_id) {
					return brand_from_cart_of_entity
				}

				return b
			})
		}

	}
	// -------- ADD A NEW BRAND PRODUCT/COMBO ------------
	else {
		final_brands_array.push(get_formatted_brand_object({ entity_from_body, store_id, delivery_slot }))
	}

	return final_brands_array;
}

export const get_formatted_cart_object = (previous_cart, req_body) => {
	const {
		product: product_from_body, combo: combo_from_body,
		coupon_code, delivery_slot, selected_location_id, brand_specific_credit_used, give_sure, special_instructions,
	} = req_body;

	const cart_object = Object.assign({}, req_body);
	const previous_cart_brands = previous_cart.brands;
	const previous_cart_selected_location_id = previous_cart.selected_location_id;

	// Assign existing cart values to the new cart body 
	cart_object.brands = previous_cart_brands;
	cart_object.coupon_code = coupon_code === coupon_code_remove_flag ? null : (coupon_code || previous_cart.coupon_code);
	cart_object.brand_specific_credit_used = brand_specific_credit_used === 0 ? 0 : (previous_cart.brand_specific_credit_used || 0);
	cart_object.give_sure = give_sure || previous_cart.give_sure;
	cart_object.special_instructions = special_instructions || previous_cart.special_instructions;

	const entity_from_body = product_from_body || combo_from_body;

	// Added prduct/combo in cart
	if (entity_from_body) {
		cart_object.brands = add_entity_to_cart(previous_cart, req_body);
	}
	// Address selected ------------------------------------
	else if (selected_location_id) {
		cart_object.selected_location_id = selected_location_id;
	} else if (delivery_slot || delivery_slot === null) {
		cart_object.brands = cart_object.brands.map(brand => {
			const newBrandObj = {
				...brand,
				order_date: get_formatted_order_date(delivery_slot),
				is_future_order: delivery_slot ? 1 : 0,
				delivery_slot,
			};

			return newBrandObj;
		})
	} else if (brand_specific_credit_used === 1 || brand_specific_credit_used === 0) {
		cart_object.brand_specific_credit_used = brand_specific_credit_used;
	} else if (special_instructions === null) {
		cart_object.special_instructions = special_instructions
	}

	cart_object.client_os = constants.clientOs;
	cart_object.source = constants.clientOs;
	cart_object.is_validate = 1;
	cart_object.selected_location_id = cart_object.selected_location_id || previous_cart_selected_location_id;
	cart_object.order_type = "takeaway";

	return cart_object;
}

export const get_updated_merged_product_and_combo_array = (updated_cart_body) => {
	let product_arr = [];
	let combo_arr = [];

	updated_cart_body.brands.forEach(b => {

		if (b.product?.length) {
			product_arr = [...product_arr, ...b.product];
		}

		if (b.combo?.length) {
			combo_arr = [...combo_arr, ...b.combo];
		}
	});

	return [product_arr, combo_arr];
}

export const add_unique_item_ids = (cart) => {
	cart.brands.forEach(b => {
		if (b?.product?.length) {
			b.product.forEach(p => {
				p.brand_id = b.brand_id;
				p.secondary_id = v4();
			})
		}

		if (b?.combo?.length) {
			b.combo.forEach(c => {
				c.brand_id = b.brand_id;
				c.secondary_id = v4();
				c.sets.forEach(s => {
					s.products.forEach(p => {
						p.secondary_id = v4()
					})
				})
			})
		}
	});

	if (cart.hasOwnProperty("payments")) {
		delete cart.payments;
	}

	if (cart.hasOwnProperty("temporary_payments")) {
		delete cart.temporary_payments;
	}

	return cart;
}

export const getCartItemsCount = (cartState)=>{
	const cartItemsCount = cartState.product.reduce(((a,b)=>{
		return(a+b.quantity);
	}),0) + cartState.combo.reduce(((a,b)=>a.quantity+b),0);
	return cartItemsCount
}

export const productDisplayPrice = (product, nearestStore, isOfferPrice = false) => {

	let { price, coupon_offer_price, offer_price } = product;
	let priceToShow = coupon_offer_price || price;
	if (isOfferPrice) {
		priceToShow = offer_price;
	};

	const tax_categories = nearestStore?.tax_categories || nearestStore?.taxCategories;

	const setTax = getTaxValue(product.tax_category, tax_categories, nearestStore?.tax);
	const displayPrice = calculatePriceWithTax({ price : priceToShow, is_back_calculate_tax : product.is_back_calculate_tax, tax:setTax });

	return displayPrice;
};

export const productDisplayPriceWithCustomization = (customizationProductArr, product, nearestStore, onlyCust = false) => {

	const originalProductPrice = product ? productDisplayPrice(product, nearestStore, false) : 0;

	if (customizationProductArr.length === 0) {
		return originalProductPrice
	};

	const totalCustomizationPrice = customizationProductArr.map((p) => productDisplayPrice(p, nearestStore, false)).reduce((a, b) => a + b, 0);

	if (onlyCust) {
		return totalCustomizationPrice
	}

	return Math.round(Number(originalProductPrice) + Number(totalCustomizationPrice))
};

export const getFormattedCGObjForCart = (selectedCustomizations, selectedCustomizationsCart) => {
	let arr = [];
	let obj = {};

	// This is used on checkout page when user edits his customization
	if (selectedCustomizationsCart) {
		selectedCustomizationsCart.forEach(group => {
			let czArrToPush = [];

			group.customisations.forEach(customization => {
				czArrToPush.push({
					name: customization.name,
					id: customization.customisation_id,
					price: customization.price,
					is_back_calculate_tax: customization.is_back_calculate_tax,
					tax_category: customization.tax_category,
				})
			});

			obj[group.id || group.group_id] = czArrToPush;
		})

		return obj;
	} else {
		Object.keys(selectedCustomizations)
			.forEach(groupId => {
				let currGroupProducts = selectedCustomizations[groupId];
				let objToPush = {
					"id": groupId,
					"customisations": [],
				};
				currGroupProducts.forEach(p => {
					objToPush.customisations.push({
						"customisation_id": p.id,
						"price": p.price,
						"offer_price_used": p.offer_price_used,
						"name": p.name,
						"is_back_calculate_tax": p.is_back_calculate_tax,
						"tax_category": p.tax_category,
					})
				})
				arr.push(objToPush);
			})
	}

	return arr;
}

export const getAllProductPriceWithCust = (cart,storeDetails)=>{
	let totalAmount = 0
	cart.product.forEach(productObj=>{

		let customizationProductsArr = []

		productObj?.customisations_groups?.forEach(group => {
			group?.customisations.forEach(customizationObj => {
				customizationProductsArr.push(customizationObj);
			})
		});
		totalAmount += productObj.quantity * productDisplayPriceWithCustomization(customizationProductsArr,productObj,storeDetails)

	})

	return totalAmount
}

export const getExternalAuth = () => {
	let authCode = idb.getItemSync('esx_internal_auth');
	let code = setExternalAuth(authCode);

	return code;
}
export const getSessionTime = () => {
	let retVal = {};
	try {
		const sessionStartTime = parseInt(idb.getItemSync('session-start-time'));
		let sessionTime = new Date().getTime() - sessionStartTime;
		let minutes = Math.floor(sessionTime / 60000)
		let seconds = ((sessionTime / 1000) % 60).toFixed();
		retVal = { SESSION_TIME_IN_MINUTES: `${minutes}:${seconds}`, SESSION_TIME_IN_SECONDS: Math.round(sessionTime / 1000) }
	} catch (err) { }
	return retVal;
}
export const setExternalAuth = (security_code) => {
	let code = security_code;
	let check_prod_kiosk = (window.location.origin.indexOf('pos.eatsure.com') > -1 )
	const params = window?.location?.search || "";
	const passedCode = new URLSearchParams(params).get('kiosk_security_code');
	if(passedCode && Number(passedCode) > 0){
		code = passedCode;
	}
	while (!code || (code && code.length>0 && isNaN(Number(code)) ) || (check_prod_kiosk && !sc_codes.production.includes(code)) || (!check_prod_kiosk && !sc_codes.staging.includes(code))) {
		if(passedCode && Number(passedCode) > 0){
			try{
				handler(BACK_FROM_KIOSK, {message: "Incorrect Security code!"});
				break;
			}catch(err){
				console.log("Error: jsBridgeHandler BACK_FROM_KIOSK");
				console.log(err);
				break;
			}
		} else {
			alert(code?"Incorrect Security code!":"No security code Found");
			code = prompt("Enter correct security code?");
		}
	}
	idb.setItemSync('esx_internal_auth', code);
	return code;
}

//To check the device type
export const isKiosk = () =>{
	if(window.innerWidth>1024 && window.innerHeight > 1366){
		return true;
	}
	return false;
}

//get Device Id
export const getDeviceId = () => {
    return idb.getItemSync('device_id') || 'default';
} 

export const getUnavailableProductIds = ({brands})=>{
	const products = []
	brands.forEach(brand=>{
		if(!brand.is_all_available){
			brand.product.forEach(prod=>{
				if(!prod.is_available){
					products.push(prod.product_id)
				}
			})
		}else if(brand.is_all_unavailable){
			brand.product.forEach(prod=>{
				products.push(prod.product_id)
			})
		}
	})
	return products
}
export const  getBrandIds = (brands) => {
	let item_ids = "";
	brands?.forEach((b, i) => {
		if (b?.product?.length) {
			item_ids += b.product.map(p => p.product_id).join(", ");
		} else if (b?.products?.length) {
			item_ids += b.products.map(p => p.product_id).join(", ");
		}
		if (b?.combo?.length) {
			item_ids += ", ";
			item_ids += b.combo.map(p => p.combo_id).join(", ");
		}
		const isLast = i === (brands.length - 1);
		if (!isLast) {
			item_ids += ", ";
		}
	})
	return item_ids;
}